angular.module('galilai.creator').controller('PublishController', function ($scope, $rootScope, $timeout, api) {

    $scope.caption = null
    $scope.currentReader = null
    $scope.postText = null
    $scope.loading = false
    $scope.currentPost = null

    const MAX_CAPTION_LENGTH = 2000
    const MAX_HASHTAGS = 25
    const MAX_POSTS_PER_DAY = 3
    let publishHelpArticle = _trans.publish.helpInstagram

    const MAX_POST_DURATION = {
        'story': 60,
        'reels': 3 * 60, // 3 minutes
    }
    const suggestedTimes = [
        '9:00',
        '11:00',
        '12:00',
        '14:00',
        '18:00',
        '20:00',
    ]
    const availableMinutes = [
        '00',
        '15',
        '30',
        '45'
    ]
    let availableHours = [];
    for (var i = 0; i < 24; i++) {
        var hourAdd = (i+7)
        if (hourAdd > 23) {
            hourAdd = hourAdd - 24
        }
        var hour = ('0' + hourAdd).slice(-2);
        availableHours.push(hour);
    }

    function getPostLanguage() {
        if ($scope.currentPost && $scope.currentPost.meta && $scope.currentPost.meta.language) {
            return $scope.currentPost.meta.language
        }
        return null
    }

    const providersPerTarget = {
        'linkedin': ['linkedin'],
        'facebook': ['instagram', 'facebook', 'both'],
        // An account connected directly publishes to Instagram and nowhere else, so this is the
        // single entry that makes updateForms settle the target on its own
        'instagram': ['instagram'],
    }

    const providersFormats = {
        'linkedin': ['post', 'reels'],
        'facebook': ['post', 'reels', 'story'],
        'instagram': ['post', 'reels', 'story'],
        'default': ['post', 'reels', 'story'],
    }

    $scope.state = {
        view: {
            editCaption: false,
            pagesDropdown: false,
            publishTab: 'publish',
            historyDropdown: false,
            showPublishHelp: false,
            publishHelpTitle: null,
        },
        plan: {
            upgrade: false,
            waitForPlan: false
        },
        captions: {
            history: [
            ],
        },
        social: {
            fixedHashtags: '',
            maxSize: MAX_CAPTION_LENGTH,
            facebookPostEnabled: window.IS_FACEBOOK_POST_ENABLED,
            suggestedTimes: suggestedTimes,
            pages: [],
            when: 'now',
            target: 'instagram',
            type: 'post',
            time: suggestedTimes[0],
            selectedHour: '09',
            selectedMinute: '00',
            selectedDate: null,
            scheduleAt: null,
            availableHours: availableHours,
            availableMinutes: availableMinutes,
            publishStatus: null,
            publishDetails: null,
            needAuth: true,
            needUpgrade: false,
            showEditDate: true,
            duration: 0,
        },
        postId: null,
    }

    // External events
    window.addEventListener('message', function(event) {
        if (event.data && event.data.name == 'stopAndCleanCaptions') {
            $timeout(function() {
                $scope.stopAndCleanCaptions()
            })
        }
    })
    $scope.instructions = _trans.publish.instructions

    $scope.selectBusiness = function(business) {
        $scope.business = business
        $scope.businessDropdown = false

        if (!$scope.state.social.original) {
            $scope.state.social.original = $scope.state.social.pages
        }
        $scope.state.social.pages = $scope.state.social.original.filter(function(page) {
            if (business.name.toLowerCase().indexOf('gali') != -1 && page.name.toLowerCase().indexOf('gali') != -1) {
                return true
            }
            if (business.name.toLowerCase().indexOf('growth') != -1 && page.name.toLowerCase().indexOf('growth') != -1) {
                return true
            }
            if (business.name.toLowerCase().indexOf('design') != -1 && page.name.toLowerCase().indexOf('design') != -1) {
                return true
            }
            return false;
        })

        $scope.state.social.activePage = null
    }

    $scope.businessDropdown = false
    $scope.businesses = []

    $rootScope.$watch('postId', function(newValue, oldValue) {
        if (newValue == null || typeof newValue === 'undefined') {
            return
        }
        if ($scope.state.postId != newValue) {
            $scope.state.postId = newValue
            $scope.onPost()
        }
    })

    let interval = null
    $scope.$watch('caption', function(newValue, oldValue) {
        if (newValue == null || typeof newValue === 'undefined') {
            return
        }
        if (oldValue == null || typeof oldValue === 'undefined') {
            return
        }
        if (interval) {
            $timeout.cancel(interval)
        }
        // Limit to maxSize
        if (newValue.length > $scope.state.social.maxSize) {
            $scope.caption = $scope.caption.substring(0, $scope.state.social.maxSize)
        }

        interval = $timeout(() => {
            $rootScope.caption = $scope.caption
            $rootScope.$broadcast('captionUpdated', {caption: $scope.caption})
        }, 500)
    })

    let intervalFixedHashtags = null
    $scope.$watch('state.social.fixedHashtags', function(newValue, oldValue) {
        console.log('state.social.fixedHashtags', newValue, oldValue)
        if (newValue == null || typeof newValue === 'undefined') {
            return
        }
        if (oldValue == null || typeof oldValue === 'undefined') {
            return
        }
        if (intervalFixedHashtags) {
            $timeout.cancel(intervalFixedHashtags)
        }

        if (!$scope.currentPost || !$scope.currentPost.project || !$scope.currentPost.project) {
            return
        }
        intervalFixedHashtags = $timeout(() => {
            api.updateProjectDefaultHashtags($scope.currentPost.meta.project, {hashtags: $scope.state.social.fixedHashtags})
            .catch(function(error) {
                logError({
                    message: 'Error updating project hashtags',
                    error: error
                })
            })
        }, 200)
    })

    $scope.autoExpand = function(e) {
        var element = typeof e === 'object' ? e.target : document.getElementById(e);
    		var scrollHeight = element.scrollHeight; // replace 60 by the sum of padding-top and padding-bottom
        element.style.height =  scrollHeight + "px";
    };

    $scope.selectCaptionHistory = function(caption) {
        $scope.caption = caption.text
        $scope.state.view.historyDropdown = false
        track('Editor Caption History Select')
    }

    $scope.addCaptionToHistory = function() {
        try {
            if ($scope.caption && $scope.caption.trim().length > 0) {
                $scope.state.captions.history.push({
                    text: $scope.caption,
                    name: $scope.caption.slice(0, 40) + '...',
                })
            }
        } catch (e) {
            logError({
                message: 'Error adding caption to history',
                error: e
            })
        }
    }
    $scope.stopGenerating = function() {
        if ($scope.currentReader) {
            $scope.currentReader.cancel()
            $timeout(() => {
                $scope.currentReader = null
            })
            $rootScope.$broadcast('captionUpdated', {caption: $scope.caption})
            $scope.addCaptionToHistory()
        }
    }

    $scope.stopAndCleanCaptions = function() {
        $scope.stopGenerating()
        $scope.caption = ''
        $rootScope.$broadcast('captionUpdated', {caption: $scope.caption})
    }

    $scope.generate = function(type) {
        track('Editor Generate Caption', {
            type: type
        })
        if ($scope.caption && $scope.caption.trim().length > 0 && !$scope.captionInstructions) {
            showConfirm(gettext('label.already_caption_filled'), null, function(status) {
                if (status) {
                    angular.noop()
                    if ($scope.postText && $scope.postText.length > 0) {
                        $scope.generateCaption({text: $scope.postText}, type)
                    } else {
                        track('Editor Generate Caption Empty Post Confirm', {
                            type: type
                        })
                        showError(gettext('error.empty_post_text_caption'))
                    }
                }
            })
            return
        }
        if ($scope.postText && $scope.postText.length > 0) {
            $scope.generateCaption({text: $scope.postText}, type)
        } else {
            track('Editor Generate Caption Empty Post', {
                type: type
            })
            showError(gettext('error.empty_post_text_caption'))
        }
    }

    $scope.generateWithCheck = function() {
        if ($scope.caption && $scope.caption.trim().length > 0) {
            return
        }
        if ($scope.postText && $scope.postText.length > 0) {
            $scope.generateCaption({text: $scope.postText}, 'new')
        } else {
            showError(gettext('error.empty_post_text_caption'))
        }
    }

    $scope.copyLegend = function() {
        copyToClipboard($scope.caption)
    }

    $rootScope.$on('animator.duration', function(event, data) {
        if (data.duration) {
            $scope.state.social.duration = data.duration/1000
        }
    })

    $scope.generateCaption = function(data, typeGeneration) {
        if ($scope.state.view.publishTab != 'captions') {
            return
        }
        let formName = 'creator/caption'
        let baseText = data.text
        if ($scope.captionInstructions && $scope.captionInstructions.trim().length > 0) {
            if ($scope.caption && $scope.caption.trim().length > 0 && typeGeneration == 'modify') {
                baseText = $scope.caption
            }
            baseText += '\n---\n' + $scope.captionInstructions + '\n'
            if (typeGeneration == 'modify') {
                formName = 'creator/chat'
            }
        }

        let input = {
            form: formName,
            inputs: {
                context: baseText,
                language: getPostLanguage(),
            }
        }
        // Custom captions for provider
        try {
            if ($scope?.state?.social?.activePage?.provider && $scope?.state?.social?.activePage?.provider != 'facebook') {
                let provider = $scope.state.social.activePage.provider
                input.inputs[provider] = provider
            }
        } catch (e) {
            console.log('Error adding provider to input', e)
        }

        if ($scope.state.captions.history.length == 0) {
            $scope.addCaptionToHistory()
        }

        let text = ''
        $scope.loading = true

        function improveResult(text) {
            text = text.replace(/^"/, '')
            text = text.replace(/^'/, '')
            text = text.replace(/^“/, '')
            text = text.replace(/^‘/, '')
            text = text.replace(/"$/, '')
            text = text.replace(/'$/, '')
            text = text.replace(/”$/, '')
            text = text.replace(/’$/, '')
            text = text.replace(/\*\*/g, '')
            return text
        }
        api.generateStream(input, function(err, response, done, reader) {
            $scope.currentReader = reader;

            if (err) {
                showError(gettext('error.generating.content'))
                $timeout(() => {
                    $scope.loading = false
                })
                return
            }
            response = improveResult(response)
            text += response;
            $timeout(() => {
                $scope.caption = text
                //$scope.autoExpand('caption-text')
                let element = document.getElementById('caption-text')
                if (element) {
                    element.scrollTop = element.scrollHeight
                }

                if (done) {
                    $timeout(() => {
                        $scope.loading = false
                        $scope.cleanHashTags()
                        $timeout(angular.noop)
                    })
                    $scope.stopGenerating()
                    return
                }
            })
        })
    }

    function getPostPage() {
        if (!$scope.currentPost || !$scope.currentPost?.publish?.items) {
            return null
        }
        // Get page id from first item
        let item = $scope.currentPost.publish.items[0]
        if (!item || !item.pageId) {
            return null
        }
        let page = $scope.state.social.pages.find(function(page) {
            return page.id == item.pageId
        })
        if (!page) {
            return null
        }
        return page
    }

    function getPageFromProject() {
        if (!$scope.currentPost || !$scope.currentPost.project || !$scope.currentPost.project) {
            return
        }
        let project = $scope.currentPost.project
        if (!project.data || !project.data.global || !project.data.global.config || !project.data.global.config.defaultPage) {
            return
        }
        let defaultPage = $scope.state.social.pages.find(function(page) {
            return page.id == project.data.global.config.defaultPage
        })
        if (!defaultPage) {
            return
        }
        return defaultPage
    }

    $scope.loadInitialPage = function() {
        if (!$scope.state.social.pages || $scope.state.social.pages.length < 1) {
            return
        }
        try {
            let defaultPage = getPostPage() || getPageFromProject()
            if (defaultPage) {
                $scope.state.social.activePage = defaultPage
                updateForms($scope?.state?.social?.activePage)
            }
            $timeout(angular.noop)
        } catch (e) {
            console.log('Error loading initial page', e)
        }
    }

    $scope.loadInitialHashtags = function() {
        if (!$scope.currentPost || !$scope.currentPost.project || !$scope.currentPost.project) {
            return
        }
        let project = $scope.currentPost.project
        if (!project.data || !project.data.global || !project.data.global.config || !project.data.global.config.hashtags) {
            return
        }
        $scope.state.social.fixedHashtags = project.data.global.config.hashtags
    }

    $scope.setupEvents = function() {

        $rootScope.$on('doFacebookAuth', function(event, data) {
            $scope.doFacebookAuth()
        })

        $rootScope.$on('startMonitoringSocialPages', function(event, data) {
            $scope.startMonitoringSocialPages()
        })

        $rootScope.$on('showInstructions', function(event, data) {
            $scope.showInstructions()
        })

        $rootScope.$on('publishContent', function(event, data) {
            $scope.state.view.publishTab = data.type || 'publish'
            if (data.source == 'bulkSchedule') {
                if (!data.caption || data.caption.length < 1) {
                    $scope.state.view.publishTab = 'captions'
                }
            }
            $scope.postText = data.text
            $scope.currentPost = data.post
            if ($scope.currentPost.data.format) {
                $scope.state.social.type = $scope.currentPost.data.format
            }
            if (!data.caption || data.caption.length < 1) {
                $scope.generateCaption(data, 'new')
            } else {
                $scope.caption = data.caption
            }

            $scope.loadInitialPage()
            $scope.loadInitialHashtags()
        })

        $rootScope.$on('publishHidden', function(event, data) {
            $scope.stopGenerating()
        })
        // Listen for any click event on the document
        document.addEventListener('click', function(event) {
            if ($scope.state.view.pagesDropdown) {
                $timeout(() => {
                    $scope.state.view.pagesDropdown = false
                })
            }
            if ($scope.state.view.historyDropdown) {
                $timeout(() => {
                    $scope.state.view.historyDropdown = false
                })
            }
        }, false)
    }

    $scope.loadPost = function(post) {
        $scope.currentPost = post
        if (post?.data?.caption) {
            $scope.caption = post.data.caption
        }
        if ($scope.currentPost.data.format) {
            $scope.state.social.type = $scope.currentPost.data.format
        }
        let calendar = $scope?.currentPost?.meta?.calendar
        if (calendar?.what) {
            $scope.state.social.type = calendar.what
        }
        if (calendar?.where) {
            $scope.state.social.target = calendar.where
        }
        if (calendar?.date) {
            $scope.state.social.when = 'custom'
            $scope.state.social.selectedDate = new Date(calendar.date)
        }
        if (calendar?.time) {
            $scope.state.social.time = 'custom'
            let parts = calendar.time.split(':')
            // Make sure to pad with 0 if only one digit
            $scope.state.social.selectedHour = ('0' + parts[0]).slice(-2)
            $scope.state.social.selectedMinute = ('0' + parts[1]).slice(-2)
        }
        if (calendar?.date && calendar?.time) {
            $scope.state.social.showEditDate = false
        }

        waitForSocialPages().then(() => {
            $scope.loadInitialPage()
        })
        $scope.loadInitialHashtags()
        $scope.refreshScheduled()
        $scope.updatePostPublishStatus()
    }

    $scope.notifyPostUpdated = function(status) {
        let time = '';
        let hour = $scope.state.social.selectedHour
        let minute = $scope.state.social.selectedMinute
        hour = ('0' + hour).slice(-2)
        minute = ('0' + minute).slice(-2)
        time = hour + ':' + minute

        window.postMessage({
            name: 'postScheduleUpdated',
            id: $rootScope.postId || $scope.currentPost?._id || null,
            schedule: {
                date: $scope.state.social.scheduleAt,
                time: time,
                where: $scope.state.social.target,
                what: $scope.state.social.type,
                status: status,
            }
        }, '*')

        $rootScope.$emit('publish.statusUpdated', {
            postId: $rootScope.postId || $scope.currentPost?._id || null,
            schedule: {
                date: $scope.state.social.scheduleAt,
                time: time,
                where: $scope.state.social.target,
                what: $scope.state.social.type,
                status: status,
            }
        })

        localStorage.setItem('galilai.posts.schedule.update', JSON.stringify({
            name: 'postScheduleUpdated',
            id: $rootScope.postId || $scope.currentPost?._id || null,
            schedule: {
                date: $scope.state.social.scheduleAt,
                time: time,
                where: $scope.state.social.target,
                what: $scope.state.social.type,
                status: status,
            }
        }))
        localStorage.removeItem('galilai.posts.schedule.update')
    }

    $scope.cleanHashTags = function() {
        let originalCaption = $scope.caption;
        try {
            function getHashtagsFromText(text) {
                if (!text) return [];
                let hashtags = text.match(/#[a-zA-Z0-9\u00C0-\u00FF]+/g);
                return hashtags || [];
            }

            function getNonHashtagText(text) {
                if (!text) return '';
                return text.replace(/#[a-zA-Z0-9\u00C0-\u00FF]+/g, '').trim();
            }

            let caption = $scope.caption;
            if (!caption || typeof caption !== 'string') return;

            let fixedHashtagsField = $scope.state.social.fixedHashtags || '';
            let fixedHashtags = getHashtagsFromText(fixedHashtagsField);
            let fixedText = getNonHashtagText(fixedHashtagsField);

            let hashtags = getHashtagsFromText(caption);
            let newHashtags = hashtags.map(h => h.toLowerCase());
            let newCaption = caption;

            // add fixed hashtags if not already included
            fixedHashtags.forEach(fixedHashtag => {
                if (newHashtags.indexOf(fixedHashtag.toLowerCase()) === -1) {
                    newHashtags.push(fixedHashtag);
                }
            });

            // remove existing hashtags from caption
            hashtags.forEach(hashtag => {
                newCaption = newCaption.replace(hashtag, '');
            });

            newHashtags = newHashtags.filter(h => h.trim().length > 0);
            newCaption = newCaption.trim();

            // append fixed non-hashtag text (if not already present)
            if (fixedText) {
                const captionLower = newCaption.toLowerCase();
                const fixedLower = fixedText.toLowerCase();
                if (!captionLower.includes(fixedLower)) {
                    if (!newCaption.endsWith('\n')) newCaption += '\n\n';
                    newCaption += fixedText.trim();
                }
            }

            // append hashtags
            if (newHashtags.length > 0) {
                newHashtags = newHashtags.slice(0, MAX_HASHTAGS);
                let newCaptionTemp = newCaption + '\n\n';
                newHashtags.forEach(hashtag => {
                    if (newCaptionTemp.length + hashtag.length + 1 < MAX_CAPTION_LENGTH) {
                        newCaptionTemp += hashtag + ' ';
                    }
                });
                $scope.caption = newCaptionTemp.trim();
            } else {
                $scope.caption = newCaption.trim();
            }
        } catch (e) {
            logError({
                message: 'Error cleaning hashtags',
                error: e
            });
            $scope.caption = originalCaption;
        }
    };
    $scope.schedulePost = function(postData) {
        if (!$scope.state.social.activePage) {
            showError(gettext('error.please_select_page'))
            $rootScope.$emit('schedule.error', {
                kind: 'publish',
                error: 'error.please_select_page'
            })
            return
        }
        if ($scope.state.social.needUpgrade && ($scope.state.social.target == 'facebook' || $scope.state.social.target == 'both')) {
            showError(gettext('error.you_need_to_reconnect_for_facebook_permissions'))
            $rootScope.$emit('schedule.error', {
                kind: 'publish',
                error: 'error.you_need_to_reconnect_for_facebook_permissions'
            })
            return
        }

        if ((!$scope.caption || $scope.caption.trim().length < 1) && $scope.state.social.type != 'story') {
            showError(gettext('error.please_add_caption'))
            $rootScope.$emit('schedule.error', {
                kind: 'caption',
                error: 'error.please_add_caption'
            })
            $scope.changePublishTab('captions')
            return
        }
        if (!$scope.state.social.target) {
            showError(gettext('error.please_select_target'))
            $rootScope.$emit('schedule.error', {
                kind: 'publish',
                error: 'error.please_select_target'
            })
            return
        }
        if (!$scope.isFormatVisible($scope.state.social.type)) {
            showError(gettext('error.please_select_format'))
            $rootScope.$emit('schedule.error', {
                kind: 'publish',
                error: 'error.please_select_format'
            })
            return
        }
        if (!$scope.isTargetVisible($scope.state.social.target)) {
            showError(gettext('error.please_select_target'))
            $rootScope.$emit('schedule.error', {
                kind: 'publish',
                error: 'error.please_select_target'
            })
            return
        }

        let isVideo = $scope.state.social.type == 'reels' || ($scope.state.social.type == 'story' && $scope?.currentPost?.data?.mediaFormat == 'video')
        if (isVideo && MAX_POST_DURATION[$scope.state.social.type] && $scope.state.social.duration > MAX_POST_DURATION[$scope.state.social.type]) {
            showError(gettext('error.post_duration_exceeded', MAX_POST_DURATION[$scope.state.social.type]))
            return
        }

        $scope.cleanHashTags()
        let pages = [
            $scope.state.social.activePage.id,
        ]
        $scope.loading = true
        let scheduleAt = $scope.state.social.scheduleAt
        if (scheduleAt) {
            scheduleAt = scheduleAt.toUTCString()
        }
        let postId = $rootScope.postId || $scope.currentPost?._id || null
        api.schedulePost({
            'postId': postId,
            'updatePost': postData || {},
            'pages': pages,
            'scheduleAt': scheduleAt || 'now',
            'type': $scope.state.social.type,
            'target': $scope.state.social.target,
            'localeScheduleAt': getLocaleDate($scope.state.social.scheduleAt || new Date()),
        }).then(function(response) {
            if (!response.data.success) {
                showError(gettext('error_publish.' + response.data.error))
                return
            }
            $scope.state.social.publishStatus = 'pending'
            if (response?.data?.totalSameDay >= MAX_POSTS_PER_DAY) {
                $scope.state.social.publishStatus = 'error'
                showError(gettext('success.scheduling_post_limit'))
            } else {
                // When coming from fast mode do not show success message
                if (postData) {
                    showNotification(gettext('success.scheduling_post'))
                } else {
                    showSuccess(gettext('success.scheduling_post'))
                }
            }
            $scope.updatePostPublishStatus()
            $scope.notifyPostUpdated('publish')

            setTimeout(() => {
                $rootScope.checkReviewFeature('download_or_schedule')
            }, 1000)
            track('Editor Publish Schedule', {
                target: $scope.state.social.target,
                type: $scope.state.social.type,
            })
        })
        .catch(function(error) {
            console.log('Error scheduling post', error)
            showError(gettext('error.scheduling_post'))
        })
        .finally(function() {
            $timeout(() => {
                $scope.loading = false
            })
        })
    }

    $scope.hasBeenScheduled = function() {
        return $scope.state.social.publishStatus && $scope.state.social.publishStatus != 'no_publish' && $scope.state.social.publishStatus != 'error'
    }

    $scope.shouldShowPublishStatus = function() {
        return $scope.state.social.publishStatus && $scope.state.social.publishStatus != 'no_publish'
    }

    $scope.showSocialConnect = function() {
        //#socialconnect-modal
        let socialConnectModal = angular.element('#socialconnect-modal')
        if (socialConnectModal) {
            socialConnectModal.modal('show')
        }
    }
    let intervalMonitoring = null
    $scope.startMonitoringSocialPages = function() {
        if (intervalMonitoring) {
            clearInterval(intervalMonitoring)
        }
        let startTime = new Date().getTime()
        intervalMonitoring = setInterval(function() {
            api.getSocialPages(startTime).then(function(response) {
                let data = response.data
                let isRecent = false
                if (data && data.updatedAt) {
                    // updatedAt is epoch seconds in utc. make sure to compare with utc (start time is in utc)
                    let updatedAt = new Date(data.updatedAt)
                    if (updatedAt.getTime() > startTime) {
                        isRecent = true
                    }
                }
                if (data.success && isRecent) {
                    showSuccess(gettext('label.success_generic'))
                    clearInterval(intervalMonitoring)
                    $timeout(() => {
                        $scope.getSocialPages()
                    })
                }
            }).catch(function(error) {
                // TASK - No handling
                console.log('Auth', error)
            })
        }, 3000)
    }

    $scope.doMobileFacebookAuth = function() {
        let token = localStorage.getItem('auth.token')
        if (!token) {
            showError(gettext('error.generic'))
            return
        }
        let info = null
        try {
            info = base64Encode(`token=${token}`)
        } catch (e) {
            showError(gettext('error.generic'))
            return
        }
        // TODO - test here
        window.open(window.BASE_URL + "/social-media-connect?info=" + info, '_system')
        $scope.startMonitoringSocialPages()
    }

    $scope.doFacebookAuth = function() {
        if (!$rootScope.isProCustomer()) {
            let publishModal = angular.element('#publish-modal')
            if (publishModal) {
                publishModal.modal('hide')
            }
            track('Editor Publish Instagram Open')
            $rootScope.showUpgrade('Publish Post Directly')
            return
        }
        if (IS_APP) {
            $scope.doMobileFacebookAuth()
            return
        }
        doLoginFB(function(token) {
            api.authenticateFacebookUser(token).then(function(response) {
                console.log('authenticateFacebookUser', response)
                if (response.data.success) {
                    $timeout(() => {
                        $scope.getSocialPages()
                    })
                } else {
                    showError(gettext('error.authenticating_facebook'))
                }
            })
            .catch(function() {
                // TASK - No handling
            })
        })
    }

    $scope.refreshScheduled = function() {
        if ($scope.state.social.when == 'now') {
            $scope.state.social.scheduleAt = null
            return
        }
        if ($scope.state.social.when == 'today') {
            $scope.state.social.selectedDate = new Date()
        }
        if ($scope.state.social.when == 'tomorrow') {
            let tomorrow = new Date()
            tomorrow.setDate(tomorrow.getDate() + 1)
            $scope.state.social.selectedDate = tomorrow
        }
        // Check if selected date is in the past if so, set to today
        let selectedDate = $scope.state.social.selectedDate
        if (selectedDate) {
            let today = new Date()
            today.setHours(0)
            today.setMinutes(0)
            today.setSeconds(0)
            today.setMilliseconds(0)
            if (selectedDate.getTime() < today.getTime()) {
                $scope.state.social.selectedDate = today
                selectedDate = today
            }
        }

        // Check if selected date is valid date
        if (!selectedDate) {
            $scope.state.social.scheduleAt = null
            return
        }
        if ($scope.state.social.time != 'custom') {
            let parts = $scope.state.social.time.split(':')
            $scope.state.social.selectedHour = parts[0]
            $scope.state.social.selectedMinute = parts[1]
        }
        let selectedHour = $scope.state.social.selectedHour
        let selectedMinute = $scope.state.social.selectedMinute
        if (!selectedHour || !selectedMinute) {
            $scope.state.social.scheduleAt = null
            return
        }
        let scheduleAt = new Date(selectedDate)
        scheduleAt.setHours(selectedHour)
        scheduleAt.setMinutes(selectedMinute)
        scheduleAt.setSeconds(0)
        scheduleAt.setMilliseconds(0)
        $scope.state.social.scheduleAt = scheduleAt
        $timeout(angular.noop)
    }

    $scope.changePublishWhen = function(when) {
        $scope.state.social.when = when
        $scope.refreshScheduled()
    }

    $scope.changePublishTime = function(time) {
        $scope.state.social.time = time
        $scope.refreshScheduled()
    }

    $scope.canPublishType = function() {
        if (!$rootScope.isPremiumCustomer() && $scope.state.social.type == 'reels') {
            let publishModal = angular.element('#publish-modal')
            if (publishModal) {
                publishModal.modal('hide')
            }
            $rootScope.showUpgrade('Publish Reels')
            return false
        }
        return true
    }

    $scope.changePublishType = function(type) {
        $scope.state.social.type = type
        if (type == 'reels') {
            track('Editor Publish Reels Click')
            if (!$scope.canPublishType()) {
                $scope.state.social.type = 'post'
                return
            }
            let currentProvider = $scope?.state?.social?.activePage?.provider
            let isFacebookProvider = currentProvider == 'facebook'

            if (!isFacebookProvider) {
                if (providersFormats[currentProvider] && providersFormats[currentProvider].includes('reels')) {
                    $scope.state.social.target = currentProvider
                } else {
                    $scope.state.social.target = null
                }
            }
        }
        $rootScope.$emit('changeFormat', {
            format: type
        })

        if (type == 'story' || type == 'reels') {
            $rootScope.$emit('changePostSize', {
                size: 'story'
            })
        }
    }

    $scope.changePublishTarget = function(target) {
        $scope.state.social.target = target
    }

    $scope.publishInstagram = function() {
        if (!$rootScope.isProCustomer()) {
            let publishModal = angular.element('#publish-modal')
            if (publishModal) {
                publishModal.modal('hide')
            }
            track('Editor Publish Instagram Open')
            $rootScope.showUpgrade('Publish Post Directly')
            return
        }

        if (!$scope.canPublishType()) {
            return
        }

        if ($scope.state.social.needAuth) {
            $scope.showSocialConnect()
        } else {
            $scope.schedulePost()
        }
    }

    $scope.cancelPublish = function() {
        let postId = $rootScope.postId || $scope.currentPost?._id || null
        api.cancelPublish(postId).then(function(response) {
            if (response.data.success) {
                $scope.state.social.publishStatus = 'no_publish'
                $scope.state.social.publishDetails = null
                showSuccess(gettext('success.canceling_publish'))
                $scope.notifyPostUpdated('no_publish')
            } else {
                showError(gettext('error.canceling_publish'))
            }
        })
        .catch(function(error) {
            showError(gettext('error.canceling_publish'))
        })
    }

    let socialPagesLoaded = false
    function waitForSocialPages() {
        return new Promise((resolve) => {
            if (socialPagesLoaded) {
                resolve()
                return
            }
            let interval = setInterval(() => {
                if (socialPagesLoaded) {
                    clearInterval(interval)
                    resolve()
                }
            }, 1000)
        })
    }

    $scope.getSocialPages = function() {
        if (!isLoggedIn()) {
            $scope.state.social.needAuth = true
            return
        }

        $scope.loading = true
        api.getSocialPermissions().then(function(response) {
            let data = response.data
            let permissions = data.permissions
            if (!permissions.error && (typeof permissions['pages_manage_posts'] === 'undefined' || permissions['pages_manage_posts'] != 'granted')) {
                $scope.state.social.needUpgrade = true
            } else {
                $scope.state.social.needUpgrade = false
            }
        })
        .catch(function() {
            // TASK - No handling
        })

        api.getSocialPages().then(function(response) {
            let data = response.data
            if (data.type == 'reauth_required') {
                $scope.state.social.reauthRequired = true
            }
            if (data.success) {
                $scope.state.social.needAuth = false
                $scope.state.social.pages = data.pages || []

                if ($scope?.state?.social?.activePage) {
                    updateForms($scope?.state?.social?.activePage)
                }
            } else {
                $scope.state.social.needAuth = true
            }
        }).catch(function(error) {
            $timeout(() => {
                $scope.state.social.needAuth = true
            })
        })
        .finally(function() {
            socialPagesLoaded = true
            $timeout(() => {
                $scope.loading = false
            })
        })
    }

    $scope.isFormatVisible = function(format) {
        let currrentProvider = $scope?.state?.social?.activePage?.provider || 'default'
        try {
            return providersFormats[currrentProvider].includes(format)
        } catch (e) {
            return providersFormats['default'].includes(format)
        }
    }

    $scope.isTargetVisible = function(target) {
        let currrentProvider = $scope?.state?.social?.activePage?.provider
        if (target == 'linkedin' && currrentProvider == 'linkedin') {
            return true
        }

        if ((target == 'facebook' || target == 'both' || target == 'instagram') && currrentProvider == 'facebook') {
            return true
        }

        // Without this, updateForms sets the target and then immediately clears it again
        if (target == 'instagram' && currrentProvider == 'instagram') {
            return true
        }
        return false
    }

    function updateForms(page) {
        try {
            if (!page) {
                return
            }
            let found = false
            if (providersPerTarget[page.provider]) {
                providersPerTarget[page.provider].forEach(function(target) {
                    if (target == $scope.state.social.target) {
                        found = true
                    }
                })
            }
            if (!found) {
                $scope.state.social.target = null
            }
            // If provider is only one then set target to provider
            if (providersPerTarget[page.provider] && providersPerTarget[page.provider].length == 1) {
                $scope.state.social.target = providersPerTarget[page.provider][0]
            }

            if (!$scope.isFormatVisible($scope.state.social.type)) {
                $scope.state.social.type = null
            }
            if (!$scope.isTargetVisible($scope.state.social.target)) {
                $scope.state.social.target = null
            }
        } catch (e) {
            console.log('Error updating forms', e)
        }
    }

    $scope.selectActivePage = function(page) {
        if (!page.has_instagram && page.provider == 'facebook') {
            $scope.showInstructions(gettext('label.no_instagram_enabled'))
            return
        }
        $scope.state.social.activePage = page
        updateForms(page)
        if (!$scope.currentPost || !$scope.currentPost.meta || !$scope.currentPost.meta.project || !page || !page.id) {
            return
        }
        api.updateProjectDefaultPage($scope.currentPost.meta.project, {id: page.id})
        .catch(function(error) {
            logError({
                message: 'Error updating project default page',
                error: error
            })
        })
    }

    $scope.togglePagesDropdown = function() {
        $timeout(function() {
            $scope.state.view.pagesDropdown = !$scope.state.view.pagesDropdown
        })
    }

    $scope.toogleHistoryDropdown = function() {
        $timeout(function() {
            $scope.state.view.historyDropdown = !$scope.state.view.historyDropdown
        })
    }

    let monitoringInterval = null
    $scope.updatePostPublishStatus = function() {
        if (!isLoggedIn()) {
            return
        }
        let postMonitoringStatus = true

        function checkStatus() {
            let postId = $rootScope.postId || $scope.currentPost?._id || null
            if (!postId) {
                postMonitoringStatus = false
                return
            }
            api.checkPostStatus(postId).then(function(response) {
                let data = response.data
                $scope.state.social.publishStatus = data.status
                $scope.state.social.publishProcessingStatus = data.processing
                if (data.kind && gettext('error_publish.' + data.kind)) {
                    $scope.state.social.publishErrorMessage = gettext('error_publish.' + data.kind)
                }
                $scope.state.social.publishDetails = data.details
                $timeout(angular.noop)
            })
            .catch(function() {
                // TASK - No handling
            })
            .finally(function() {
                if ($scope.state.social.publishStatus == 'no_publish') {
                    postMonitoringStatus = false
                    return
                }
            })
        }
        checkStatus()
        if (monitoringInterval) {
            clearInterval(monitoringInterval)
        }
        monitoringInterval = setInterval(function() {
            if (postMonitoringStatus) {
                checkStatus()
            } else {
                clearInterval(monitoringInterval)
            }
        }, 1500)
    }

    $scope.stopMonitoring = function() {
        if (monitoringInterval) {
            clearInterval(monitoringInterval)
        }
    }

    $scope.onPost = function() {
        $scope.getSocialPages()
        $scope.updatePostPublishStatus()
    }

    $scope.initPublishValues = function() {
        let params = new URLSearchParams(window.location.search)
        function getParameterByName(name) {
            return params.get(name)
        }

        // Read params pDate, pTime, pType, pTarget
        let pDate = getParameterByName('pdate')
        let pTime = getParameterByName('ptime')
        let pType = getParameterByName('ptype')
        let pTarget = getParameterByName('ptarget')
        if (pType) {
            $scope.state.social.type = pType
        }
        if (pTarget) {
            $scope.state.social.target = pTarget
        }
        if (pDate) {
            $scope.state.social.when = 'custom'
            $scope.state.social.selectedDate = new Date(pDate)
        }
        if (pTime) {
            $scope.state.social.time = 'custom'
            let parts = pTime.split(':')
            // Make sure to pad with 0 if only one digit
            $scope.state.social.selectedHour = ('0' + parts[0]).slice(-2)
            $scope.state.social.selectedMinute = ('0' + parts[1]).slice(-2)
        }
        if (pDate && pTime) {
            $scope.state.social.showEditDate = false
        }
    }

    $scope.init = function() {
        console.log('Init publish controller')
        $scope.setupEvents()
        $scope.initPublishValues()
        $scope.refreshScheduled()
    }

    $scope.showInstructions = function(title) {
        $scope.state.view.publishHelpTitle = title || null
        $scope.state.view.showPublishHelp = true
    }

    $scope.changePublishTab = function(tab) {
        $scope.state.view.publishTab = tab
        track('Editor Publish Tab', {
            tab: tab
        })
        if (tab == 'captions') {
            $scope.generateWithCheck()
        }
    }
})
